/* eslint-disable @typescript-eslint/no-explicit-any */

import _Vue from 'vue';

const VueSegment = {
  install(Vue: typeof _Vue): void {
    const handler = {
      get: function (target: any, prop: string) {
        if (target && target[prop]) {
          return target[prop];
        }
        return {};
      },
    };
    const segment: any = new Proxy(window, handler);

    Vue.prototype.$segment = segment.analytics;
  },
};

export default VueSegment;
